import { WhatsNewSection } from './WhatsNew';
import { ProfessionalCreatorSection } from './ProfessionalCreatorSection';

export const CreatorInformationSections = ({ isLive }: { isLive: boolean }) => {
  if (!isLive) return null;
  return (
    <div className="flex flex-col gap-8">
      <ProfessionalCreatorSection />
      <WhatsNewSection />
    </div>
  );
};
